import { useCallback } from "react";
import { Link } from "react-router";
import { readMemory } from "../../api/threads/memoriesApi";
import { useLoad } from "../../shared/loading/useLoad";
import { appPaths } from "../../shared/routing/appPaths";

/** A link to a memory's own small Thread (ADR-0031 D5), once its record names one; nothing before. */
export default function MemoryThreadLink({ projectId, memoryId, label }: { projectId: string; memoryId: string; label: string }) {
  const load = useCallback((signal: AbortSignal) => readMemory(projectId, memoryId, signal), [projectId, memoryId]);
  const { state } = useLoad(load);
  const keptIn = state.status === "loaded" ? state.value.keptIn : null;
  return keptIn === null ? null : <Link to={appPaths.thread(keptIn)} className="app-link text-xs underline">{label}</Link>;
}
